module.exports = __webpack_public_path__ + "media/sub6-3-1.92ee9331.mp4";